import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { PATH_PAYMENTS } from "../constants/urlPaths";
import { Middleware } from "@reduxjs/toolkit";// or appropriate base URL
import {
    GetSpreedlyCredentialsSuccessResponse,
    GetSpreedlyCredentialsFailureResponse,
} from "redmond";
import { getIframeAuthHeaders } from "../utils/sessionTokenUtil";

export const spreedlyCredentialsApi = createApi({
    reducerPath: "SpreedlyCredentials",
    baseQuery: fetchBaseQuery({
        baseUrl: PATH_PAYMENTS,
        prepareHeaders: (headers) => {
            Object.entries(getIframeAuthHeaders()).forEach(([key, value]) =>
                headers.set(key, value)
            );
            return headers;
        },
    }),
    tagTypes: ["SpreedlyCredentials"],
    endpoints: (build) => ({
        getSpreedlyCredentials: build.query<GetSpreedlyCredentialsSuccessResponse | GetSpreedlyCredentialsFailureResponse, void>({
            query() {
                return {
                    url: "spreedlyCredentials",
                    method: "GET",
                };
            },
            providesTags: ["SpreedlyCredentials"],
        }),
    }),
});
export const spreedlyCredentialsApiMiddleware: Middleware = spreedlyCredentialsApi.middleware;
export const { useGetSpreedlyCredentialsQuery } = spreedlyCredentialsApi;
